import { render, staticRenderFns } from "./UploadDocumentWithChain.vue?vue&type=template&id=936b7932&scoped=true"
import script from "./UploadDocumentWithChain.vue?vue&type=script&lang=js"
export * from "./UploadDocumentWithChain.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentWithChain.vue?vue&type=style&index=0&id=936b7932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936b7932",
  null
  
)

export default component.exports